export const default_sign_in_config = [
  "about_url",
  "auth_domain",
  "authentication_url",
  "qr_token",
  "salt",
  "depended_services"
];
